// Currently we don't have a way to set or fetch custom descriptions, so this serves as a placeholder
export const DESCRIPTION_FALLBACK =
  'Short description - tone of voice, expressions etc.';
